module.exports = __webpack_public_path__ + "static/media/juho.70f116cf.jpg";